import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Layout } from '@app/layout';
import { BlogIndexPage, BlogPostPage, MainPage, NotFoundPage, QuestPage, TeamBuildingPage } from '@pages';
import { PAGE_SLUGS, QUEST_IDS } from '@app/lib/site';

// Структура URL: /{lang}/, /{lang}/{slug}/, /{lang}/blog/, /{lang}/blog/{slug}/. Корень / перенаправляется на /en/ (public/_redirects).
export function AppRoutes(): React.JSX.Element {
  return (
    <Routes>
      <Route path=":lang" element={<Layout />}>
        <Route index element={<MainPage />} />
        {QUEST_IDS.map((id) => (
          <Route key={id} path={PAGE_SLUGS[id]} element={<QuestPage quest={id} />} />
        ))}
        <Route path={PAGE_SLUGS.team} element={<TeamBuildingPage />} />
        <Route path="blog" element={<BlogIndexPage />} />
        <Route path="blog/:slug" element={<BlogPostPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
      <Route path="*" element={<Layout />} />
    </Routes>
  );
}
